<ng-template [ngTemplateOutlet]="element" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>

<ng-template #typ00>
  @if (item?.isNavigierbar) {
    <cap-link [params]="[item.id.id]" [placement]="tooltipPlacement" [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
      <ng-template [ngTemplateOutlet]="common00"></ng-template>
    </cap-link>
  } @else {
    {{ item | formatTimepoint }}
  }
  <ng-template #common00>
    {{ item | formatTimepoint }}
  </ng-template>
  <small>
    <ng-template [ngTemplateOutlet]="dokument"></ng-template>
  </small>
</ng-template>

<ng-template #typ01>
  @if (item?.isNavigierbar) {
    <cap-link [params]="[item.id.id]" [placement]="tooltipPlacement" [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
      <ng-template [ngTemplateOutlet]="common01"></ng-template>
    </cap-link>
  } @else {
    {{ item?.eingangTagebuch | datum }}
    {{ item | formatTimepoint }}
  }
  <ng-template #common01>
    {{ item?.eingangTagebuch | datum }}
    {{ item | formatTimepoint }}
  </ng-template>
  <ng-template [ngTemplateOutlet]="dokument"></ng-template>
</ng-template>

<ng-template #dokument>
  @if (item) {
    @if (isCmisGeschaeftConfigured) {
      <cap-cmis [target]="{ itemType: 'Geschaeft', id: item.id?.id, tooltipParam: item | formatTimepoint }"></cap-cmis>
    } @else {
      <cap-dokulink [item]="dokuLinkBuilderFactory.create('GESCHAEFT').setEntry(item).build()"></cap-dokulink>
    }
  }
</ng-template>

<ng-template #loeschgeschaeft>
  @if (item?.type == "GB_GESCHAEFT") {
    @if (item?.isNavigierbar) {
      <cap-link
        [params]="[item.id.id]"
        [placement]="tooltipPlacement"
        [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT"
        [tooltipOverride]="'DetailsZumLöschgeschaeftAnzeigen'">
        <span class="loeschgeschaeft">
          <ng-template [ngTemplateOutlet]="value"></ng-template>
        </span>
      </cap-link>
    } @else {
      <small class="text-secondary">
        ({{ "Loeschbeleg" | translate }}: {{ item?.eingangTagebuch | datum }} {{ item | formatTimepoint }})</small
      >
    }
    <small>
      @if (isCmisGeschaeftConfigured) {
        <cap-cmis
          [target]="{ itemType: 'Geschaeft', id: item.id?.id, tooltipParam: item | formatTimepoint }"></cap-cmis>
      } @else {
        <cap-dokulink [item]="dokuLinkBuilderFactory.create('GESCHAEFT').setEntry(item).build()" #link></cap-dokulink>
      }
    </small>
  }

  @if (item?.type == "GEO_GESCHAEFT") {
    @if (item?.isNavigierbar) {
      <cap-link [params]="[item.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
        <ng-template [ngTemplateOutlet]="geoValue"></ng-template>
      </cap-link>
    } @else {
      <small class="text-secondary">
        ({{ "Loeschbeleg" | translate }}: {{ item?.namePolitischeGemeinde }} ,
        {{ item?.geschaeftsnummer | formatGeometergeschaeftsnummer }})
      </small>
    }
  }

  @if (item?.type == "SIMPLE") {
    <ng-template [ngTemplateOutlet]="lsimple_timepoint"></ng-template>
  }

  <ng-template #value>
    <small class="text-secondary">
      ({{ "Loeschbeleg" | translate }}: {{ item?.eingangTagebuch | datum }} {{ item | formatTimepoint }})</small
    >
  </ng-template>

  <ng-template #geoValue>
    <small class="text-secondary">
      ({{ "Loeschbeleg" | translate }}: {{ item?.namePolitischeGemeinde }}
      , {{ item?.geschaeftsnummer | formatGeometergeschaeftsnummer }})
    </small>
  </ng-template>
</ng-template>

<ng-template #lsimple_timepoint class="loeschgeschaeft">
  <small class="text-secondary"> ({{ "Loeschbeleg" | translate }}: {{ item.zeitpunktRechtsgueltig | datumZeit }}
    ) </small>
</ng-template>

<ng-template #simple_timepoint let-item> {{ "ÄnderungOhneGeschäft" | translate }}
  , {{ item.zeitpunktRechtsgueltig | datum }}
</ng-template>

<ng-template #ersterfassung>
  {{ "Ersterfassung" | translate }}
</ng-template>

<ng-template #ersterfassung_uebergeben>
  {{ "ErsterfassungÜbergeben" | translate }}
</ng-template>

<ng-template #geometergeschaeft>
  @if (item?.isNavigierbar) {
    <cap-link [params]="[item.id.id]" [target]="navTargets.NAV_GEOMETERGESCHAEFT">
      <ng-template [ngTemplateOutlet]="geoGeschaeftValue"></ng-template>
    </cap-link>
  } @else {
    {{ item?.namePolitischeGemeinde }},
    {{ item?.geschaeftsnummer | formatGeometergeschaeftsnummer }}
  }
  <ng-template #geoGeschaeftValue>
    {{ item?.namePolitischeGemeinde }},
    {{ item?.geschaeftsnummer | formatGeometergeschaeftsnummer }}
  </ng-template>
</ng-template>
